<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '招待费报备' ,path:'/item'}"></Title>


    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px">

        <el-divider content-position="left">报备信息</el-divider>

        <el-form-item label="报备项目" prop="projectId">
          <el-select style="margin-right: 15px; width: 50%" v-model="ruleForm.projectId" placeholder="请选择报备项目"
                     filterable>
            <el-option
                v-for="item in projectList"
                :key="item.projectId"
                :label="item.projectName"
                :disabled="item.projectState === 6"
                :value="item.projectId">
                <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
                <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
                <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="报备类型" prop="costType" required>
          <el-radio-group v-model="ruleForm.costType">
            <el-radio label="1">餐饮</el-radio>
            <el-radio label="2">烟</el-radio>
            <el-radio label="3">酒</el-radio>
            <el-radio label="4">礼品</el-radio>
            <el-radio label="5">其他</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="消费时间" prop="costType" required>
          <el-date-picker
              v-model="ruleForm.useTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="请选择消费时间">
          </el-date-picker>

        </el-form-item>

        <el-form-item label="预估金额" prop="costMoney">
          <el-input v-model="ruleForm.costMoney" maxlength="12">
            <template slot="append">{{ getDigitUppercase }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="申请事由" prop="reportSubject">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                    v-model="ruleForm.reportSubject"></el-input>
        </el-form-item>

        <el-form-item label="消费人" prop="useUserType" required>
          <el-radio-group v-model="ruleForm.useUserType">
            <el-radio label="1">我自己</el-radio>
            <el-radio label="2">其他人</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="ruleForm.useUserType == 2">
          <el-form-item label="实际消费人" prop="useUser">
            <el-select style="margin-right: 15px;" v-model="ruleForm.useUser" placeholder="请选择实际消费人"
                       filterable>
              <el-option
                  v-for="item in userList"
                  :key="item.userId"
                  :label="item.realName"
                  :value="item.userId">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <!--    -->
        <el-Form-item>
          <el-button v-if="submitShow" type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
        </el-Form-item>

      </el-form>

    </el-card>
  </div>


</template>

<script>
import Title from "../../Title";
import {digitUppercase, isNum} from "../../../util";
import {
  requestAllProject,
  requestAllUser,
  requestCostReportApply,
  requestProjectApply,
  requestSaveSysUser,
  requestApplyDetail
} from "../../../api";

export default {
  components: {Title},
  name: "CostReportApply",
  data() {
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        this.ruleForm.costMoney = value
        callback();
      }
    };
    return {
      submitShow: true,

      dialogVisible: false,
      projectList: [],
      userList: [],

      applyServiceId: "",
      applyType: "",
      costReportId: null,
      applyId: null,
      reapply: false,

      ruleForm: {
        projectId: "",
        costType: "1",
        costMoney: "",
        reportSubject: "",

        /**/
        useTime: "",//new Date().getTime() + 3600 * 1000 * 5 * 1,
        useUserType: "1",
        useUser: "",


      },
      rules: {
        projectId: [
          {required: true, message: '请选择报备项目', trigger: 'blur'},
        ],
        costMoney: [
          {required: true, validator: validatePrice, trigger: 'blur'},
        ],
        reportSubject: [
          {required: true, message: '请输入申请事由', trigger: 'blur'},
          {max: 500, message: '长度最大500个字符', trigger: 'blur'}
        ],
        useUser: [
          {required: true, message: '请选择实际报备人', trigger: 'blur'},
        ],

      },

    }

  },
  computed: {
    getDigitUppercase() {
      return digitUppercase(this.ruleForm.costMoney)
    },
  },
  created() {
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getObject()
    }
    this.getAllProject()
    this.getAllUser()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          this.submitShow = false
          if (this.reapply) {
            this.ruleForm.applyId = this.applyId
            this.ruleForm.costReportId = this.costReportId
            this.ruleForm.reapply = this.reapply
          }
          requestCostReportApply(this.ruleForm).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.resetForm('ruleForm')
              this.ruleForm.useTime = ""
              if (this.reapply) {
                this.$router.push({query: {}})
                this.reapply = false
              }
              this.submitShow = true

            } else {
              this.$message.error(res.msg);
              this.submitShow = true
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 查询所有人
    getAllUser() {
      requestAllUser({}).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.userList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    // 查询所有项目
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            let detail = res.object.detail
            this.costReportId = detail.costReportId
            for (let key in this.ruleForm) {
              this.ruleForm[key] = detail[key].toString()
            }
            this.ruleForm.useUser = parseInt(detail.useUser)
            this.ruleForm.projectId = parseInt(detail.projectId)
            this.ruleForm.useUserType = detail.useUserType.toString()
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.resetForm.useTime = ""
    }
  }
}
</script>

<style scoped>

</style>




